import React from 'react';

import * as S from '@/components/CustomReports/Results/styles';

interface RiskColorColumnProps {
	isLastColumn: boolean;
	isFirstColumn: boolean;
	riskColor: string;
	isMoreThanOne: boolean;
}

export function RiskColorColumn(props: Readonly<RiskColorColumnProps>): JSX.Element | null {
	const { isLastColumn, isFirstColumn, riskColor, isMoreThanOne } = props;

	if (!isLastColumn) {
		return null;
	}

	return <S.RiskRowTable $isFirstColumn={isFirstColumn} $riskColor={riskColor} $isMoreThanOne={isMoreThanOne} />;
}
